import React, { useState, useEffect, useRef, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../../css/dashboard.css"
import axios from 'axios';
import CommonTable from "../component/table_list/common_table";
import CommonTableRow from "../component/table_list/common_tablerow";
import CommonTableColumn from "../component/table_list/common_tablecolumn";
import Pagination from "react-js-pagination";
import styled from "styled-components"

function ReserveAS(props) {

    const location = useLocation();
    const navigate = useNavigate();
    const [isValidAccess, setIsValidAccess] = useState(false); // 유효한 접근 상태

    const [asList, setASList] = useState([]);
    const [page, setPage] = useState(1);
    const items = 10;
    const hadlePageChange = (page) => { setPage(page) };
    const [reserveCount, setReserveCount] = useState(0);

    const [view, setView] = useState(false);
    const [selectMenu, setSelectMenu] = useState("전체");
    const [searchText, setSearchText] = useState(''); // 검색 입력 상태
    const [searchQuery, setSearchQuery] = useState(''); // 실제 검색 쿼리 상태

    const [asToDelete, setASToDelete] = useState(null);
    const deleteDialogRef = useRef();

    const getASRegist = useCallback(async () => {
        try {
            const getPage = (page - 1) * 10;
            const params = searchQuery.trim() !== '' ? { query: searchQuery } : {};
            let url = `/ASRegist/${getPage}`;

            switch (selectMenu) {
                case "전체":
                    url = `/ASRegist/${getPage}`;
                    break;
                case "접수":
                    url = `/ASRegist/Status/0/${getPage}`;
                    break;
                case "처리":
                    url = `/ASRegist/Status/1/${getPage}`;
                    break;
                case "완료":
                    url = `/ASRegist/Status/2/${getPage}`;
                    break;
                default:
                    url = `/ASRegist/${getPage}`;
            }

            const reserve_result = await axios.get(url, { params });
            setASList(reserve_result.data.message);
        } catch (error) {
            console.error('Error fetching reservation count:', error.message);
        }
    }, [page, selectMenu, searchQuery]);

    // 검색 핸들러
    const handleSearch = () => {
        setPage(1);
        setSearchQuery(searchText); // 검색 버튼 클릭 시에만 쿼리 업데이트
    };

    // Enter 키 핸들러
    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleSearch();
        }
    };

    // [수정 2] useCallback으로 감싸서 불필요한 재생성 방지
    const getReserveCount = useCallback(async () => {
        try {
            let url = '/ASRegistCount';

            switch (selectMenu) {
                case "전체":
                    url = '/ASRegistCount';
                    break;
                case "접수":
                    url = '/ASRegist/StatusCount/0';
                    break;
                case "처리":
                    url = '/ASRegist/StatusCount/1';
                    break;
                case "완료":
                    url = '/ASRegist/StatusCount/2';
                    break;
                default:
                    url = '/ASRegistCount';
            }

            const reserve_result = await axios.get(url);
            setReserveCount(reserve_result.data.message);
        } catch (error) {
            console.error('Error fetching reservation count:', error.message);
        }
    }, [selectMenu]);

    // [수정 3] 의존성 배열에 getASRegist 추가
    useEffect(() => {
        getASRegist();
    }, [getASRegist]);

    // [수정 4] 의존성 배열에 사용하는 모든 함수와 변수 추가
    useEffect(() => {
        setIsValidAccess(true);
        getASRegist();
        getReserveCount();
    }, [location.state, navigate, getASRegist, getReserveCount]);

    // 유효한 접근이 아닌 경우 렌더링하지 않음
    if (!isValidAccess) {
        return null;
    }

    const handleSelect = (menu) => {
        setSelectMenu(menu);
        setView(false);
        setPage(1);
    }

    const openDeleteDialog = (as) => {
        setASToDelete(as);
        deleteDialogRef.current.showModal();
    };

    const confirmDeleteAS = async () => {
        try {
            const result = await axios.delete(`/ASRegist/${asToDelete.idx}`);
            alert(result.data.message);
            getASRegist(); // 삭제 후 목록 갱신
            deleteDialogRef.current.close();
        } catch (error) {
            console.error('Error deleting as:', error.message);
        }
    };

    return (
        <div className="dashboard-container">
            <div className="content-container">
                <div style={{ marginTop: '20px', width: '90%', margin: '20px auto 0', position: 'relative' }}>
                    <TopBarContainer>
                        {/* 검색 UI (히든 처리) */}
                        {/* <SearchContainer>
                            <SearchInput
                                type="text"
                                placeholder="예약번호, 아이디, 연락처, 주소, AS내용으로 검색..."
                                value={searchText}
                                onChange={(e) => setSearchText(e.target.value)}
                                onKeyPress={handleKeyPress}
                            />
                            <SearchButton onClick={handleSearch}>검색</SearchButton>
                        </SearchContainer> */}

                        {/* 필터 UI */}
                        <FilterContainer>
                            <FilterButton onClick={() => setView(!view)}>
                                {selectMenu}
                                <span style={{ fontSize: '12px', color: '#999' }}>▼</span>
                            </FilterButton>
                            {view && (
                                <DropdownList>
                                    {['전체', '접수', '처리', '완료'].map((menu) => (
                                        <DropdownItem key={menu} onClick={() => handleSelect(menu)}>
                                            {menu}
                                        </DropdownItem>
                                    ))}
                                </DropdownList>
                            )}
                        </FilterContainer>
                    </TopBarContainer>
                </div>
                <div style={{ marginTop: '10px' }}>
                    <CommonTable headerTitle={['No', 'AS번호', '아이디', '연락처', '주소', 'A/S내용', '세척일자', '에어컨 종류', '수량', '담당 기사', '담당 상담원', 'AS상태']}>
                        {
                            asList.map((reserve, index) => {
                                return (
                                    <CommonTableRow key={index} idx={reserve.idx} beforePage={'/reserve_as'} kind={'as'}>
                                        <CommonTableColumn>{reserveCount - ((page - 1) * 10) - index}</CommonTableColumn>
                                        <CommonTableColumn>{reserve.as_number || '-'}</CommonTableColumn>
                                        <CommonTableColumn>{reserve.id}</CommonTableColumn>
                                        <CommonTableColumn>{reserve.phone_num}</CommonTableColumn>
                                        <CommonTableColumn>{reserve.address || ''}</CommonTableColumn>
                                        <CommonTableColumn>{reserve.as_content}</CommonTableColumn>
                                        <CommonTableColumn>{reserve.work_date}</CommonTableColumn>
                                        <CommonTableColumn>{reserve.aircon_kind}</CommonTableColumn>
                                        <CommonTableColumn>{reserve.aircon_count}</CommonTableColumn>
                                        <CommonTableColumn>{reserve.manager}</CommonTableColumn>
                                        <CommonTableColumn>{reserve.advisor}</CommonTableColumn>
                                        <CommonTableColumn>{reserve.state}</CommonTableColumn>
                                    </CommonTableRow>
                                )
                            })
                        }
                    </CommonTable>
                </div>
                <PaginationBox>
                    <Pagination
                        activePage={page}
                        itemsCountPerPage={items}
                        totalItemsCount={reserveCount}
                        pageRangeDisplayed={10}
                        onChange={hadlePageChange}>
                    </Pagination>
                </PaginationBox>
            </div>

            <dialog ref={deleteDialogRef} style={{ width: '300px', }}>
                <h2 style={{ textAlign: 'center' }}>AS 내역 삭제</h2>
                <div style={{ textAlign: 'center' }}>
                    {asToDelete && (
                        <div>
                            <p>{asToDelete.title} (ID: {asToDelete.id})</p>
                            <p>AS 내역을 삭제하시겠습니까?</p>
                        </div>
                    )}
                </div>
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                    <button
                        style={{ marginRight: '10px', padding: '10px 20px', fontSize: '12px' }}
                        onClick={() => deleteDialogRef.current.close()}
                    >
                        취소
                    </button>
                    <button
                        style={{ padding: '10px 20px', fontSize: '12px' }}
                        onClick={confirmDeleteAS}
                    >
                        확인
                    </button>
                </div>
            </dialog>
        </div>
    );
}

const PaginationBox = styled.div`
    margin-top: 20px;

    .pagination {
        display: flex;
        justify-content: center;
        margin-top: 15px;
    }

    ul {
        list-style: none;
        padding: 0;
    }

    ul.pagination li {
        display: inline-block;
        width: 30px;
        height: 30px;
        border: 1px solid #e2e2e2;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 1rem;
    }

    ul.pagination li:first-child {
        border-radius: 5px 0 0 5px;
    }

    ul.pagination li:last-child {
        border-radius: 0 5px 5px 0;
    }

    ul.pagination li a {
        text-decoration: none;
        color: #337ab7;
        font-size: 1rem;
    }

    ul.pagination li.active a {
        color: white;
    }

    ul.pagination li.active {
        background-color: #337ab7;
    }

    ul.pagination li a:hover,
    ul.pagination li a.active {
        color: blue;
    }
`;

const FilterContainer = styled.div`
            position: relative;
            max-width: 120px;
`;

const TopBarContainer = styled.div`
    display: flex;
    gap: 15px;
    align-items: flex-start;
    margin-bottom: 10px;
`;

const SearchContainer = styled.div`
    display: flex;
    gap: 10px;
    align-items: center;
`;

const SearchInput = styled.input`
    width: 350px;
    padding: 12px 16px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    font-size: 15px;
    transition: border-color 0.2s;
    
    &:focus {
        outline: none;
        border-color: #006edc;
    }
    
    &::placeholder {
        color: #999;
    }
`;

const SearchButton = styled.button`
    padding: 12px 24px;
    background-color: #006edc;
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
    box-shadow: 0 2px 5px rgba(0,0,0,0.1);
    
    &:hover {
        background-color: #0056b3;
        box-shadow: 0 4px 8px rgba(0,0,0,0.15);
    }
`;

const FilterButton = styled.button`
    width: 100%;
    padding: 12px 16px;
    background: white;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    font-size: 15px;
    font-weight: 600;
    color: #333;
    cursor: pointer;
    transition: all 0.2s;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &:hover {
        background-color: #f8f9fa;
        border-color: #006edc;
    }
`;

const DropdownList = styled.div`
    position: absolute;
    top: calc(100% + 5px);
    left: 0;
    right: 0;
    background: white;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    z-index: 10;
    overflow: hidden;
`;

const DropdownItem = styled.div`
    padding: 12px 16px;
    cursor: pointer;
    font-size: 15px;
    color: #333;
    transition: background-color 0.2s;

    &:hover {
        background-color: #f0f7ff;
        color: #006edc;
    }

    &:not(:last-child) {
        border-bottom: 1px solid #f0f0f0;
    }
`;

export default ReserveAS;